import * as React from 'react'

import { IVisibilityProps } from './Visibility.interfaces'
import { StyledVisibility } from './Visibility.styles'

export const Visibility: React.FC<IVisibilityProps> = ({ children, ...props }) => {
  return <StyledVisibility {...props}>{children}</StyledVisibility>
}
